import { render } from "./GptQuestionPanel.vue?vue&type=template&id=4b290e33&scoped=true&ts=true"
import script from "./GptQuestionPanel.vue?vue&type=script&lang=ts"
export * from "./GptQuestionPanel.vue?vue&type=script&lang=ts"

import "./GptQuestionPanel.vue?vue&type=style&index=0&id=4b290e33&lang=scss&scoped=true"
import "./GptQuestionPanel.vue?vue&type=style&index=1&id=4b290e33&lang=scss"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b290e33"]])

export default __exports__